import * as yup from 'yup';

export const localizedField = yup.object({
  de: yup.string().required(),
  en: yup.string().required(),
});
